import React, { useRef, cloneElement } from 'react';
import { createPortal } from 'react-dom';
import { Coachmark } from '_Experimental/Coachmark';
import { getIconFromShortcode } from 'utils/shortcode';
import { useOnboardingCoachmark } from './useOnboardingCoachmark';

const OnboardingCoachmark: React.FC = (): JSX.Element | null => {
    // Ref
    const anchorRef = useRef<HTMLElement>(null);

    const {
        Anchor,
        targetElement,
        step,
        visible,
        handleNext,
        handleExit,
        handleOnClickTarget,
        isPathnameMatch,
        defaultNextCta,
        progression,
    } = useOnboardingCoachmark();

    if (!step || !isPathnameMatch || !Anchor || !targetElement) {
        return null;
    }

    const {
        placement,
        icon,
        title,
        content,
        variant = 'base',
        nextCta = defaultNextCta,
        exitCta,
    } = step;

    const parsedContent = getIconFromShortcode(content);

    return (
        <>
            {createPortal(
                <>
                    {cloneElement(Anchor, { ref: anchorRef })}
                    <Coachmark
                        anchorRef={anchorRef}
                        isOpen={visible}
                        placement={placement}
                        variant={variant}
                        onClickTarget={handleOnClickTarget}
                    >
                        {icon && <Coachmark.Icon icon={icon} />}
                        <Coachmark.Title>{title}</Coachmark.Title>
                        <Coachmark.Close onClick={handleExit} />
                        <Coachmark.Content>{parsedContent}</Coachmark.Content>
                        {exitCta && (
                            <Coachmark.Exit onClick={handleExit}>
                                {exitCta}
                            </Coachmark.Exit>
                        )}
                        <Coachmark.Next onClick={handleNext}>
                            {nextCta} {progression}
                        </Coachmark.Next>
                    </Coachmark>
                </>,
                targetElement,
            )}
        </>
    );
};

export default OnboardingCoachmark;
